import {
  WListUserSettingsRequest,
  WUserSettingMapView,
  WUserSettingRequest,
  WUserSettingView,
} from '@zola/svc-web-api-ts-client';

import ApiService from '~/util/apiService';

export const getVendorUserSetting = async (key: string) => {
  return ApiService.get<WUserSettingView>(`/web-marketplace-api/v1/vendor-user/settings/${key}`);
};

export const getVendorUserSettings = async (keys: string[]) => {
  return ApiService.post<WUserSettingMapView, WListUserSettingsRequest>(
    `/web-marketplace-api/v1/vendor-user/settings/list`,
    {
      keys,
    }
  );
};

export const setVendorUserSetting = async (key: string) => {
  return ApiService.post<WUserSettingView, WUserSettingRequest>(
    `/web-marketplace-api/v1/vendor-user/settings`,
    {
      key,
    }
  );
};
